import { FormCol, media } from 'ia-react-core';
import styled from 'styled-components';

export const StyledFormCol = styled(FormCol)`
  label {
    font-weight: normal ;
  }
  padding-left: 0px;
  ${media.sm`
    width: 120px;
    display: table-cell;
    padding-left: 8px;
  `}  
`;
export const StyledForm = styled(FormCol)`
  padding-left: 0px;
  ${media.sm`
    display: table-cell;
    width: 280px;
  `} 
`;
